import React from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  Typography,
} from "@mui/material";
import ModalAjuste from "./ModalAjuste";

const ListaAjuste = ({ Tipo, Origen }) => {
  const [modalState, setModalState] = React.useState(false);
  const [currentId, setCurrentId] = React.useState("");

  const handleOpenModal = () => {
    setCurrentId(Tipo.id);
    setModalState(true);
  };

  const handleCloseModal = () => {
    setModalState(false);
  };

  return (
    <React.Fragment>
      <Accordion className="Acordeon">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="AcordeonSummary"
        >
          <Typography className="Titulo" sx={{ width: "75%" }}>
            {Tipo.variable}
          </Typography>
          <Divider
            orientation="vertical"
            sx={{ width: "auto", height: "auto", m: 1 }}
          />
        </AccordionSummary>
        <AccordionDetails className="AcordeonDetail ">
          <Typography className="Texto truncate-text">{Tipo.valor}</Typography>
          <Button className="BotonBody" onClick={handleOpenModal}>
            Editar
          </Button>
          <div style={{ display: "flex" }}>
            <ModalAjuste
              ModalState={modalState}
              CloseModal={handleCloseModal}
              Tipo={Tipo}
              CurrentId={currentId}
              Origen={Origen}
            />
          </div>
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};

export default ListaAjuste;
